/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechPhoneClassicIcon16Light } from './TechPhoneClassicIcon16Light';
import { TechPhoneClassicIcon16Regular } from './TechPhoneClassicIcon16Regular';
import { TechPhoneClassicIcon16Solid } from './TechPhoneClassicIcon16Solid';
import { TechPhoneClassicIcon20Light } from './TechPhoneClassicIcon20Light';
import { TechPhoneClassicIcon20Regular } from './TechPhoneClassicIcon20Regular';
import { TechPhoneClassicIcon20Solid } from './TechPhoneClassicIcon20Solid';
import { TechPhoneClassicIcon24Regular } from './TechPhoneClassicIcon24Regular';
import { TechPhoneClassicIcon24Solid } from './TechPhoneClassicIcon24Solid';
import { TechPhoneClassicIcon32Regular } from './TechPhoneClassicIcon32Regular';
import { TechPhoneClassicIcon64Regular } from './TechPhoneClassicIcon64Regular';
var sizes = {
    16: {
        light: TechPhoneClassicIcon16Light,
        regular: TechPhoneClassicIcon16Regular,
        solid: TechPhoneClassicIcon16Solid,
    },
    20: {
        light: TechPhoneClassicIcon20Light,
        regular: TechPhoneClassicIcon20Regular,
        solid: TechPhoneClassicIcon20Solid,
    },
    24: {
        regular: TechPhoneClassicIcon24Regular,
        solid: TechPhoneClassicIcon24Solid,
    },
    32: {
        regular: TechPhoneClassicIcon32Regular,
    },
    64: {
        regular: TechPhoneClassicIcon64Regular,
    },
};
export var TechPhoneClassicIcon = forwardRef('TechPhoneClassicIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
